import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getProductSettings = async () => {
    const { path, method } = endpoints.companySetting.getCompanySetting;

  let err = null;
  let res: any = null;

  try {
    ({ data: res } = await request(`${host}${path}`, method, {}, {}));
  } catch (error) {
    // @ts-ignore
    err = error.message;
  }

  return [err, res];
};
